<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true"></app-header>
    <div class="ui layout" [class.loading]="isLoading">
        <div class="content">
            <div class="ui segment">
                <app-task-form #taskForm [employee]="employee" [task]="task"></app-task-form>
            </div>
            <div class="action-buttons">
                <ui-button (click)="onCancel()">{{ 'cancel' | appTranslate }} </ui-button>
                <ui-button (click)="onSave(taskForm)" type="primary"> {{ saveButtonCopy | appTranslate }} </ui-button>
            </div>
        </div>

        <div class="sidebar">
            <div class="ui segment">
                <h3 class="text-color">{{ 'employees.employee-tasks.tasksTemplates' | appTranslate }}</h3>
                <p>{{ 'employees.employee-tasks.tasksCanBeCreatedAdHocOrAsACopyOfATemplate' | appTranslate }}</p>
                <p>{{ 'employees.employee-tasks.templatesMakeItEasyToCreateOnboardingTasks' | appTranslate }}</p>
                <p>
                    <a href="{{ '4409640751895' | i18nHelpCentre }}" target="_blank">{{
                        'employees.employee-tasks.learnMore' | appTranslate
                    }}</a
                    >{{ 'employees.employee-tasks.aboutTasksAndTemplates' | appTranslate }}
                </p>
            </div>
        </div>
    </div>
</div>
